import "./styles.scss";

import { useState } from "react";

import { useApp } from "context/app";

import { Avatar, Notifications } from "./components";
import IconButton from "components/IconButton";
import Actions from "../Actions";
import TimeTracker from "components/TimeTracker";
import { WebsiteInfoModal } from "page_components/shared/tasks/modals";

import { ReactComponent as HamburgerIcon } from "assets/icons/hamburger.svg";

const mainClass = "dashboard-layout-top";

const Top = ({ actions }) => {
  const { user, setSidebarOpen } = useApp();

  const [websiteInfoId, setWebsiteInfoId] = useState(null);

  return (
    <>
      <div className={mainClass}>
        <div className={`${mainClass}__wrapper`}>
          <div className={`${mainClass}__header`}>
            <IconButton
              onClick={() => setSidebarOpen(true)}
              size="large"
              icon={<HamburgerIcon />}
            />
          </div>
          <div className={`${mainClass}__aside`}>
            {user.type !== "client" && <TimeTracker />}
            <Actions data={actions} />
            <div className={`${mainClass}__aside__buttons`}>
              <Notifications setWebsiteInfoId={setWebsiteInfoId} />
            </div>
            <Avatar />
          </div>
        </div>
      </div>

      <WebsiteInfoModal
        id={websiteInfoId}
        isOpen={!!websiteInfoId}
        onClose={() => setWebsiteInfoId(null)}
      />
    </>
  );
};

export default Top;
